import * as React from 'react'
import { FC, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getData } from '@user/store/dashboard/widgets/overdueNextActionDates/api'
import { selectOverdueNextActionDates } from '@user/store/dashboard/widgets/overdueNextActionDates/slice'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useCheckPermissions } from '@user/store/authorization/permissions'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

import { Leads } from './Sections/Leads'
import { Opportunities } from './Sections/Opportunities'
import { mapDashboardDataToFilters } from '@user/store/dashboard/mapper'

export const ContentFront: FC = () => {
  const dispatch = useAppDispatch()
  const { assigneeId, data, salesTeamId } = useSelector(
    selectOverdueNextActionDates,
  )

  const [_, assignees, __, salesTeams] = useMemo(
    () => mapDashboardDataToFilters(data),
    [data],
  )

  const [canViewLeads, canViewOpps] = useCheckPermissions(
    'leads_view',
    'opportunities_view',
  )

  useEffect(() => {
    dispatch(getData({ assigneeId, salesTeamId }))
  }, [dispatch, assigneeId, salesTeamId])

  return (
    <>
      <Leads
        count={data.leadsOverdue}
        value={data.leadsOverdueValue}
        assignees={assignees}
        salesTeams={salesTeams}
        canViewLeads={canViewLeads}
      />

      <Box my={1}>
        <Divider />
      </Box>

      <Opportunities
        count={data.opportunitiesOverdue}
        value={data.opportunitiesValue}
        assignees={assignees}
        salesTeams={salesTeams}
        canViewOpps={canViewOpps}
      />
    </>
  )
}

ContentFront.displayName = 'OverdueNextActionDatesContentFront'
